import { useEffect, useRef } from "react";

export default function ImagenModal({ imagenUrl, onCerrar }) {
  const modalRef = useRef();

  // Cierra con Escape
  useEffect(() => {
    const manejarEscape = (e) => {
      if (e.key === "Escape") {
        onCerrar();
      }
    };
    document.addEventListener("keydown", manejarEscape);
    return () => {
      document.removeEventListener("keydown", manejarEscape);
    };
  }, [onCerrar]);

  // Cierra al hacer clic fuera del contenido
  const manejarClickFondo = (e) => {
    if (modalRef.current && !modalRef.current.contains(e.target)) {
      onCerrar();
    }
  };

  if (!imagenUrl) return null;

  return (
    <div
      className="fixed inset-0 bg-black bg-opacity-90 flex items-center justify-center z-50"
      onClick={manejarClickFondo}
    >
      <div
        ref={modalRef}
        className="modal flex relative max-w-3xl w-full p-4 bg-transparent"
      >
        <button
          onClick={onCerrar}
          className="absolute top-6 right-6 text-white bg-black bg-opacity-60 w-4 h-4 justify-center flex rounded"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="lucide lucide-x-icon lucide-x w-4 h-4"
          >
            <path d="M18 6 6 18" />
            <path d="m6 6 12 12" />
          </svg>
        </button>
        <img
          src={imagenUrl}
          onClick={onCerrar}
          alt="Ampliada"
          className="w-full objectcontain rounded shadow"
        />
      </div>
    </div>
  );
}
